import { useContext } from 'react';
import KeycloakAuthContext from '../providers/KeycloakAuthProvider';

const useKeycloak = () => useContext(KeycloakAuthContext);

export default useKeycloak;
